<clare-text-input
    [metaData]="metadata"
    [theForm]="theForm"
    (onBlur)="blurHandler()"
    [notRequired]="notRequired"
    [isFullWidthField]="isFullWidthField"
></clare-text-input>
